<template>
  <div class="header">
    <LogoMark class="icon" />
    <span class="title" data-testid="page-title">
      <slot name="title">{{ title }}</slot>
    </span>
    <span class="subtitle">
      <slot name="subtitle">{{ subtitle }}</slot>
    </span>
  </div>
</template>

<script>
import LogoMark from "@/assets/svg/logo-mark.svg";

export default {
  name: "PageHeader",
  props: {
    title: String,
    subtitle: String,
  },
  components: {
    LogoMark,
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  align-items: center;

  color: $brand-dark-blue;
  text-align: center;

  margin: 40px 0 $spacing-large 0;

  @include media("<medium") {
    margin-bottom: 0;
  }

  .icon {
    stroke: $brand-dark-blue;
    height: 70px;
    stroke-width: 30;
    margin-bottom: $spacing-small;
  }

  .title {
    font-size: $title-font-size;
    font-weight: $font-bold;
    margin-bottom: $spacing-tiny;

    @include media("<medium") {
      font-size: $title-font-size-mob;
    }
  }

  .subtitle {
    font-size: $subtitle-font-size;
    color: $grey-dark;

    @include media("<medium") {
      font-size: $subtitle-font-size-mob;
    }
  }
}
</style>
